import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import React from "react";

import { NavigationProvider } from "./hooks/NavigationContext";
import { SelfServeContextProvider } from "./hooks/SelfServeContext";
import { useExistedBrandOrderEffect } from "./hooks/useExistedBrandOrderEffect";
import { SelfServeRouter } from "./SelfServeRouter";

export const SelfServeBase: React.FC = () => {
  return (
    <SelfServeContextProvider>
      <div>
        <NavigationBase />
      </div>
    </SelfServeContextProvider>
  );
};

const NavigationBase = () => {
  const queryState = useExistedBrandOrderEffect();
  if (queryState.isLoading) {
    return (
      <NavigationProvider>
        <Row align="center" justify="center">
          <LoadingSpinner size="large" />
        </Row>
      </NavigationProvider>
    );
  }
  return (
    <NavigationProvider>
      <SelfServeRouter {...queryState} />
    </NavigationProvider>
  );
};
